<template>
	<div id="login">
		<div class="loginCenter">
			<div class="loginMain" :class="{'right-panel-active': mainRight}">
				<div class="lMainContainer lMainlogin" v-if="!mainRight">
					<p class="loginMainTitle">欢迎登录</p>
					<loginForm @goBack="backpath"></loginForm>
					<a @click="toResPsd">忘记密码？点击重置</a>
				</div>
				<div class="lMainContainer lMainSign" v-else>
					<p class="loginMainTitle">注册</p>
					<signForm></signForm>
				</div>
				<div class="lMainOverlay">
					<div class="overlay">
						<div class="overlayPanel overlayLeft">
							<h1>加入我们!</h1>
							<p>欢迎加入医优库！如果您没有账号，请点击下方“注册”按钮</p>
							<button class="loginPageBtn" @click="signIn(true)"><span>注册</span></button>
						</div>
						<div class="overlayPanel overlayRight">
							<h1>已有账号?</h1>
							<p>如果你已有账号,请点击下方“登录”按钮，欢迎回来！</p>
							<button class="loginPageBtn" @click="signIn(false)"><span>登录</span></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import loginForm from '../../components/login/loginForm.vue';
	import signForm from '../../components/login/signForm.vue'
	export default {
		components: {
			loginForm,
			signForm
		},
		data() {
			return {
				mainRight: false,
				fromPath: ''
			}
		},
		methods: {
			toResPsd(){
				this.$router.push('/resPsd')
			},
			signIn(data) {
				this.mainRight = data;
			},
			backpath() {
				this.$router.push({
					path: this.fromPath,
				});
			}
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				vm.fromPath = from.fullPath;
			});
		},

	}
</script>

<style>
	#login {
		height: 100vh;
		width: 100%;
		background: url(../../assets/img/loginback.png) no-repeat;
		background-size: cover;
	}

	.loginCenter {
		padding-top: 180px;
	}

	.loginMain {
		width: 900px;
		height: 600px;
		background-image: linear-gradient(to right, #134E5E, #71B280);
		background-size: auto 100%;
		margin: 0 auto;
		position: relative;
		top: 50%;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0px 0px 10px #F2F2F2;
	}

	.lMainContainer {
		position: absolute;
		top: 0;
		height: 100%;
		transition: all 0.6s ease-in-out;
		text-align: center;
		padding: 20px;
		z-index: 999;
	}

	.lMainlogin {
		left: 0;
		width: 65%;
		background: #FFFFFF;
		padding-top: 100px;
		transform: translateX(0);
	}

	.loginMain.right-panel-active .lMainlogin {
		transform: translateX(100%);
	}

	.lMainSign {
		padding-top: 60px;
		left: 0;
		width: 65%;
		opacity: 1;
		background: #FFFFFF;
	}

	.loginMain.right-panel-active .lMainSign {
		transform: translateX(315px);
		opacity: 1;
		animation: 0.6s;
	}



	.lMainOverlay {
		position: absolute;
		top: 0;
		left: 65%;
		width: 35%;
		height: 100%;
		/* overflow: hidden; */
		transition: transform 0.6s ease-in-out;
		z-index: 100;
	}

	.loginMain.right-panel-active .lMainOverlay {
		transform: translateX(-900px);
	}

	.overlay {
		color: #FFFFFF;
		position: relative;
		height: 100%;
		width: 200%;
		transform: translateX(0);
		transition: transform 0.6s ease-in-out;
	}

	.overlayPanel {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 40px;
		text-align: center;
		top: 0;
		height: 100%;
		width: 50%;
		transform: translateX(0);
		transition: transform 0.6s ease-in-out;
	}

	.container.right-panel-active .overlayLeft {
		transform: translateX(0);
	}

	.overlayRight {
		right: 0;
		z-index: 999;
	}

	.container.right-panel-active .overlayRight {
		transform: translateX(20%);
	}

	.overlayPanel h1 {
		line-height: 60px;
		font-weight: lighter;
	}

	.overlayPanel p {
		margin-bottom: 20px;
	}


	.loginMainTitle {
		text-align: center;
		font-weight: lighter;
		font-size: 30px;
		color: #006e6b;
	}


	.loginPageBtn {
		font-family: 'Roboto', sans-serif;
		font-weight: 500;
		background: transparent;
		outline: none !important;
		cursor: pointer;
		transition: all 0.3s ease;
		position: relative;
		display: inline-block;
		color: #fff;
		width: 130px;
		height: 40px;
		line-height: 42px;
		padding: 0;
		border: none;
	}

	.loginPageBtn span {
		position: relative;
		display: block;
		width: 100%;
		height: 100%;
	}

	.loginPageBtn:before,
	.loginPageBtn:after {
		position: absolute;
		content: "";
		height: 0%;
		width: 2px;
		background: #fff;
	}

	.loginPageBtn:before {
		right: 0;
		top: 0;
		transition: all 0.1s ease;
	}

	.loginPageBtn:after {
		left: 0;
		bottom: 0;
		transition: all 0.1s 0.2s ease;
	}

	.loginPageBtn:hover:before {
		transition: all 0.1s 0.2s ease;
		height: 100%;
	}

	.loginPageBtn:hover:after {
		transition: all 0.1s ease;
		height: 100%;
	}

	.loginPageBtn span:before,
	.loginPageBtn span:after {
		position: absolute;
		content: "";
		background: #fff;
	}

	.loginPageBtn span:before {
		left: 0;
		top: 0;
		width: 0%;
		height: 2px;
		transition: all 0.1s 0.1s ease;
	}

	.loginPageBtn span:after {
		left: 0;
		bottom: 0;
		width: 100%;
		height: 2px;
	}

	.loginPageBtn span:hover:before {
		width: 100%;
	}
</style>